
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post111() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Boa tarde alguém aqui já fez ou está fazendo tratamento com a medicação keytruda junto com a quimioterapia?</title>
        <meta 
          name="description" 
          content="Boa tarde alguém aqui já fez ou está fazendo tratamento com a medicação keytruda junto com a quimioterapia?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Leana de Sá &#183; 16/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Boa tarde alguém aqui já fez ou está fazendo tratamento com a medicação keytruda junto com a quimioterapia?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/111')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  3 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Boa tarde, Leana.<br/><br/>Eu entendo que esse é um momento delicado e é natural buscar informações e apoio em grupos como este. O Keytruda é um medicamento imunoterápico utilizado em alguns tipos de câncer, muitas vezes em combinação com a quimioterapia. Cada pessoa pode reagir de forma diferente aos tratamentos, então compartilhar experiências pode ser útil, mas é essencial seguir rigorosamente as orientações do seu oncologista.<br/><br/>Se ainda não fez, sugiro também conversar com sua equipe médica sobre qualquer dúvida ou efeito colateral que você possa estar enfrentando. Eles têm o conhecimento mais detalhado sobre o seu caso específico e podem fornecer as melhores recomendações para o seu tratamento.<br/><br/>Cuide-se e, se precisar de mais alguma coisa, estou aqui para ajudar.<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 16/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/111')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/5-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Experiência lidando com diabetes  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quando fui diagnosticado com diabetes, já uns 8 anos atrás, meu primeiro sentimento foi de revolta. Porque eu?, eu pensava. Nem muito acima do peso eu estava. Porém com o tempo fui aceitando e aprendendo a viver com essa nova realidade. No fim, diabetes mudou minha vida e a forma como eu vivo. E apesar da minha revolta inicial, a maioria dessas mudanças foi para o bem. Pensando a respeito, resolvi escrever algumas coisas que aprendi desde meu diagnóstico e que talvez sejam úteis para outras pessoas.<br/><br/>Já vou começar pelo mais importante: a primeira coisa que aprendi foi que nenhum tratamento para diabetes funciona sozinho. Diabetes, talvez mais que qualquer outra doença crônica, precisa ser gerenciada pelo paciente, porque quase qualquer coisa que nós fazemos tem um efeito no nosso nível de glicose no sangue.<br/><br/>Para diabetes não tem uma pílula milagrosa que o médico vai receitar, nós (quem tem diabetes) precisa participar ATIVAMENTE do tratamento, tomando controle da nossa saúde, estudando e aprendendo sobre a doença. <br/><br/>Isso é muito trabalhoso, mas recompensador, porque mostra o nosso poder em controlar e influenciar (pelo menos parcialmente) a nossa saúde.<br/><br/>A melhor coisa que fiz logo no início, e recomendo para quem tem diabetes, é comprar um medidor de glicose, aprender a utilizar o aparelho, e medir a glicose todos os dias (e no início, mais de uma vez ao dia). Isso foi super importante para aprender como meu nível de glicose funciona, e como as coisas que afetam ele (diferentes comidas, diferentes rotinas de exercício físico). Depois de um ano fazendo isso, eu já tinha uma boa ideia de como meu corpo e meu nível de glicose respondiam aos vários estímulos, e não precisei mais medir com tanta frequência. <br/><br/>O segundo ponto importante é a alimentação. Não vou falar de dieta diretamente, porque imagino que seja diferente para cada pessoa, mas limitar a quantidade de comida foi uma das coisas mais importantes que fiz: me ajudou chegar no peso ideal e ter mais energia e disposição. Uma coisa posso falar com segurança: o controle de diabetes se beneficia da redução de calorias ingeridas, e fiz isso principalmente trocando outras carnes por peixe e aumentando a quantidade de vegetais no meu prato.<br/><br/>Depois de colocar a alimentação em ordem, a terceira coisa mais importante que fiz foi começar a me exercitar. O truque aqui foi encontrar uma maneira de fazer exercício ser algo que eu gostava. Para mim, o que funcionou foi começar a fazer natação, algo que eu sempre tinha vontade de fazer, mas nunca tinha começado. A diabetes foi o catalisador para isso, e hoje todas as semanas, gosto muito e me faz muito bem.<br/><br/>Espero que essa minha experiência sirva e possa dar algumas ideias para quem está começando a enfrentar essa situação agora. Com controle e esforço, é possível viver com uma qualidade de vida ainda melhor do que antes da diabetes!!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/5')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Paula Farber &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/94-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Alguém com diabetes, que tem fezes moles e diarréia constante?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/94')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Joana Costa &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/54-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Essa semana chegou a última quimioterapia, e vou na médica também pra ver resultado dos exames<br/>Até aqui o senhor me acompanhou e mim ajudou.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/54')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        2 comentários
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marcela Prattes &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/51-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa noite pessoal<br/>Descobri um câncer no rim e decidi que não vou cuidar .<br/>Não quero cuidar estimativa de vida 5 anos
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/51')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            Esse post foi útil?
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Danna Rosa &#183; 10/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/58-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, fui diagnosticada com diabetes tipo 1 e to tomando insulina. Me ensinaram a aplicar na barriga, mas queria saber se dá pra aplicar na coxa e se dói menos
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/58')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
